import { useEffect, useState } from "react";
import { configApi } from "../api";

type Configs = {
    googleTagManagerId: string | undefined;
    showSpeechOutputBrowser: boolean;
    showSpeechOutputAzure: boolean;
    showChatHistoryBrowser: boolean;
    showChatHistoryCosmos: boolean;
    environment: string | undefined;
};

const DEFAULT_CONFIGS: Configs = {
    googleTagManagerId: undefined,
    showSpeechOutputBrowser: false,
    showSpeechOutputAzure: false,
    showChatHistoryBrowser: false,
    showChatHistoryCosmos: false,
    environment: undefined
};

// Shared across every useConfigs() caller so /config is fetched once per page load.
let configsPromise: Promise<Configs> | undefined;

function loadConfigs(): Promise<Configs> {
    configsPromise ??= configApi()
        .then(config => ({
            googleTagManagerId: config.googleTagManagerId ?? undefined,
            showSpeechOutputBrowser: config.showSpeechOutputBrowser,
            showSpeechOutputAzure: config.showSpeechOutputAzure,
            showChatHistoryBrowser: config.showChatHistoryBrowser,
            showChatHistoryCosmos: config.showChatHistoryCosmos,
            environment: config.environment
        }))
        .catch(error => {
            console.error("Failed to load config, falling back to defaults", error);
            // Allow a later mount to retry instead of caching the failure.
            configsPromise = undefined;
            return DEFAULT_CONFIGS;
        });
    return configsPromise;
}

export const useConfigs = () => {
    const [configs, setConfigs] = useState<Configs>(DEFAULT_CONFIGS);
    useEffect(() => {
        let cancelled = false;
        loadConfigs().then(loaded => {
            if (!cancelled) setConfigs(loaded);
        });
        return () => {
            cancelled = true;
        };
    }, []);

    return configs;
};
